import React from "react";
import styles from "./index.module.scss";

const CMS = () => {
  return (
    <div className={styles.container}>
      <h2 style={{ marginBottom: 20 }}>Commission Structure</h2>
      <p style={{ fontSize: "20px", fontWeight: "bold" }}>Commission = Platform Charge + Handling Fees + Transaction Fees + TDS(1%) + TCS(1%)</p>
      <table>
        <tr style={{ color: "white" }}>
          <th style={{ background: "#3a9206" }}>Category</th>
          <th style={{ background: "#3a9206" }}>Platform Fees</th>
          <th style={{ background: "#3a9206" }}>Handling Fees</th>
          <th style={{ background: "#3a9206" }}>Transaction Fees</th>
        </tr>
        <tr>
          <td style={{ fontWeight: "bold" }}>Mobiles</td>
          <td>1.15%</td>
          <td>100</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td style={{ fontWeight: "bold" }}>Mobile Accessories</td>
        </tr>
        <tr>
          <td>Chargers</td>
          <td>4.30%</td>
          <td>100</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Cables</td>
          <td>6.30%</td>
          <td>100</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Power Banks</td>
          <td>6.30%</td>
          <td>100</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td colSpan={3} style={{ fontWeight: "bold" }}>Audio</td>
        </tr>
        <tr>
          <td>Home Theatres</td>
          <td>3.30%</td>
          <td>200</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Speakers</td>
          <td>3.30%</td>
          <td>200</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Earphones/Headphones</td>
          <td>2.30%</td>
          <td>100</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td colSpan={3} style={{ fontWeight: "bold" }}>IT</td>
        </tr>
        <tr>
          <td>Laptops</td>
          <td>2.00%</td>
          <td>200</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Tablets</td>
          <td>4.30%</td>
          <td>200</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Monitors</td>
          <td>4.30%</td>
          <td>200</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Keyboard & Mouses</td>
          <td>4.00%</td>
          <td>200</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Printers</td>
          <td>3.30%</td>
          <td>400</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td colSpan={3} style={{ fontWeight: "bold" }}>Large Appliances</td>
        </tr>
        <tr>
          <td>Televisions</td>
          <td>3.00%</td>
          <td>400</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Air-Conditioners</td>
          <td>3.00%</td>
          <td>1000</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td colSpan={3} style={{ fontWeight: "bold" }}>Washing Machines</td>
        </tr>
        <tr>
          <td>Washers/Dryers</td>
          <td>3.00%</td>
          <td>400</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Semi-Automatic</td>
          <td>3.00%</td>
          <td>800</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Fully Automatic Top Load</td>
          <td>3.00%</td>
          <td>1000</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Fully Automatic Front Load/Others</td>
          <td>3.00%</td>
          <td>1200</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td colSpan={3} style={{ fontWeight: "bold" }}>Refrigerator</td>
        </tr>
        <tr>
          <td>Single-Door</td>
          <td>4.00%</td>
          <td>1200</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Double-Door</td>
          <td>4.00%</td>
          <td>1500</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Side-By-Side/Others	</td>
          <td>4.00%</td>
          <td>2000</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td colSpan={3} style={{ fontWeight: "bold" }}>Small Appliances</td>
        </tr>
        <tr>
          <td>Air Purifiers</td>
          <td>4.00%</td>
          <td>300</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Coolers</td>
          <td>4.00%</td>
          <td>800</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Fans</td>
          <td>4.00%</td>
          <td>250</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Inverters</td>
          <td>4.00%</td>
          <td>300</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Irons</td>
          <td>4.00%</td>
          <td>150</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Room Heaters</td>
          <td>4.00%</td>
          <td>300</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Vacuum Cleaners</td>
          <td>4.00%</td>
          <td>300</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Voltage Stabilizers</td>
          <td>4.00%</td>
          <td>300</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Water Heaters/Geysers</td>
          <td>4.00%</td>
          <td>300</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Water Purifiers</td>
          <td>4.00%</td>
          <td>300</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td colSpan={3} style={{ fontWeight: "bold" }}>Kitchen Appliances</td>
        </tr>
        <tr>
          <td>Air fryers</td>
          <td>4.00%</td>
          <td>300</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Chimneys</td>
          <td>4.00%</td>
          <td>300</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Dish Washers</td>
          <td>4.00%</td>
          <td>300</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Gas Stoves</td>
          <td>4.00%</td>
          <td>250</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Hand Blenders</td>
          <td>4.00%</td>
          <td>100</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Inductions</td>
          <td>4.00%</td>
          <td>150</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Kettles</td>
          <td>4.00%</td>
          <td>150</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Microwave Oven</td>
          <td>3.00%</td>
          <td>400</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Mixer Grinders</td>
          <td>4.00%</td>
          <td>300</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>OTG</td>
          <td>4.00%</td>
          <td>300</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Pressure Cookers</td>
          <td>4.00%</td>
          <td>300</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Rice Cookers</td>
          <td>4.00%</td>
          <td>300</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Toaster & Sandwich Makers</td>
          <td>4.00%</td>
          <td>150</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td>Water Dispensers</td>
          <td>4.00%</td>
          <td>300</td>
          <td>1.70%</td>
        </tr>
        <tr>
          <td colSpan={3} style={{ fontWeight: "bold" }}>Personal Care</td>
        </tr>
        <tr>
          <td>Stylers/Dryers/Grooming</td>
          <td>4.00%</td>
          <td>100</td>
          <td>1.70%</td>
        </tr>
      </table>
      <p style={{ marginTop: 20 }}>Platform Charges and Handling Fees are based on categories mentioned above.</p>
      <p>These charges will be effective from <span style={{ fontWeight: "bold" }}>Feb 22, 2024</span>.</p>
    </div>
  );
};

export default CMS;
